//import jump from 'jump.js';
//import { getTransitionEndEventName } from '../components/utils';
let $ = window.jQuery;

class Component {

    constructor(element) {
        this.departureId = element.getAttribute('data-bill-departure-id');
        this.type        = element.getAttribute('data-bill-type');
        this.renderUrl   = element.getAttribute('data-bill-render-url');
        this.billWrapper = document.querySelector('[data-bill-wrapper]');
        this.flashClass  = 'booking-receipt--flash';
        
        this.extraOptions = Array.from(document.querySelectorAll('[data-bill-extra]'));

        if (this.type == 'reservation') {
            this.totalTravelers = document.querySelector('[data-bill-total-travelers]');
            this.inputs         = [this.totalTravelers, ...this.extraOptions];
        } else {
            this.inputs = this.extraOptions;
        }

        this.inputs.forEach(input => input.addEventListener('change', () => {
            this.update();
        }));

        $('[data-insurance-id], [data-insurance-date]').change(() => {
            this.update();
        });
    }

    getBillTable() {
        return this.billWrapper.querySelector('[data-bill-table]');
    }

    getExtraOptionIds() {
        return this.extraOptions
            .map((el) => {
                if (el.options.length > 0) {
                    return this.getSelectValue(el);
                } else {
                    return '';
                }
            })
            .filter(value => value !== '');
    }

    getInsuranceData() {
        return {
            id:   $('[data-insurance-id]').val(),
            from: $('[data-insurance-date="from"]').val(),
            to:   $('[data-insurance-date="to"]').val(),
        };
    }

    getSelectValue(el) {
        return +el.options[el.selectedIndex || 0].value;
    }

    getTotalTravelers() {
        return this.getSelectValue(this.totalTravelers);
    }

    update() {
        let data;

        if (this.type == 'reservation') {
            data = {
                departure_id:     this.departureId,
                total_travelers:  this.getTotalTravelers(),
                insurance:        this.getInsuranceData(),
                extra_option_ids: this.getExtraOptionIds(),
            };
        } else {
            data = {
                extra_option_ids: this.getExtraOptionIds(),
            };
        }

        this.updateBill(data);
    }

    updateBill(data) {
        let billTable = this.getBillTable();

        if (billTable) {
            billTable.classList.remove(this.flashClass);
        }

        window.$.post(this.renderUrl, data, (html) => {
            this.billWrapper.innerHTML = html;
            this.getBillTable().classList.add(this.flashClass);
        }, 'html');
    }
}

const enhanceElement = (element) =>
    element ? new Component(element) : false;

const enhance = () =>
    enhanceElement(document.querySelector('[data-bill]'));

export default {enhance};
